import { Application } from './application.js';
import { Charge } from './charge.js';
import { Conversation } from './conversation.js';
import { Developer } from './developer.js';
import { Erx } from './erx.js';
import { ErxV1 } from './erxV1.js';
import { ErxV2 } from './erxV2.js';
import { Fax } from './fax.js';
import { Fhir } from './fhir.js';
import { Lab } from './lab.js';
import { M2m } from './m2m.js';
import { Messaging } from './messaging.js';
import { PaymentMethod } from './paymentMethod.js';
import { Project } from './project.js';
import { Rcm } from './rcm.js';
import { Role } from './role.js';
import { Secret } from './secret.js';
import { Telemed } from './telemed.js';
import { TransactionalSMS } from './transactionalSMS.js';
import { User } from './user.js';
import { Version } from './version.js';
import { Z3 } from './z3.js';
import { Zambda } from './zambda.js';
import { ZambdaLogStream } from './zambdaLogStream.js';

// AUTOGENERATED -- DO NOT EDIT
let Oystehr$1 = class Oystehr {
    constructor(config) {
        var _a, _b, _c;
        var _d, _e, _f;
        this.config = config;
        (_a = (_d = this.config).services) !== null && _a !== void 0 ? _a : (_d.services = {});
        (_b = (_e = this.config.services)['projectApiUrl']) !== null && _b !== void 0 ? _b : (_e['projectApiUrl'] = config.projectApiUrl);
        (_c = (_f = this.config.services)['fhirApiUrl']) !== null && _c !== void 0 ? _c : (_f['fhirApiUrl'] = config.fhirApiUrl);
        this.application = new Application(config);
        this.developer = new Developer(config);
        this.m2m = new M2m(config);
        this.messaging = new Messaging(config);
        this.conversation = new Conversation(config);
        this.transactionalSMS = new TransactionalSMS(config);
        this.paymentMethod = new PaymentMethod(config);
        this.charge = new Charge(config);
        this.project = new Project(config);
        this.rcm = new Rcm(config);
        this.erxV1 = new ErxV1(config);
        this.erxV2 = new ErxV2(config);
        this.role = new Role(config);
        this.secret = new Secret(config);
        this.telemed = new Telemed(config);
        this.user = new User(config);
        this.version = new Version(config);
        this.z3 = new Z3(config);
        this.zambda = new Zambda(config);
        this.zambdaLogStream = new ZambdaLogStream(config);
        this.fax = new Fax(config);
        this.lab = new Lab(config);
        this.erx = new Erx(config);
        this.fhir = new Fhir(config);
    }
};

export { Oystehr$1 as Oystehr };
//# sourceMappingURL=index.js.map
